import { render, staticRenderFns } from "./NewRmaProducts.vue?vue&type=template&id=bb9824dc&"
import script from "./NewRmaProducts.vue?vue&type=script&lang=js&"
export * from "./NewRmaProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports